import script from "./DropdownTopArray.vue?vue&type=script&setup=true&lang=ts&generic=T%2C%20TS%20extends%20string%20%7C%20undefined%20%3D%20undefined"
export * from "./DropdownTopArray.vue?vue&type=script&setup=true&lang=ts&generic=T%2C%20TS%20extends%20string%20%7C%20undefined%20%3D%20undefined"

import "./DropdownTopArray.vue?vue&type=style&index=0&id=c5c60538&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5c60538"]])

export default __exports__